"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

var _Typography = require("../Typography");

var _UncheckedIcon = _interopRequireDefault(require("./src/UncheckedIcon"));

var _CheckedIcon = _interopRequireDefault(require("./src/CheckedIcon"));

var _IndeterminateIcon = _interopRequireDefault(require("./src/IndeterminateIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Wrap = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Checkbox__Wrap",
  componentId: "sc-1mrwuwx-0"
})(["cursor:pointer;", ""], function (props) {
  return props.disabled && "\n      opacity: 0.5;\n      mouse-events: none;\n      cursor: not-allowed;\n    ";
});

function Checkbox(_ref) {
  var checked = _ref.checked,
      value = _ref.value,
      label = _ref.label,
      checkedIcon = _ref.checkedIcon,
      uncheckedIcon = _ref.uncheckedIcon,
      onChange = _ref.onChange,
      color = _ref.color,
      disabled = _ref.disabled,
      name = _ref.name,
      props = _objectWithoutProperties(_ref, ["checked", "value", "label", "checkedIcon", "uncheckedIcon", "onChange", "color", "disabled", "name"]);

  var toggle = _react["default"].useCallback(function (e) {
    if (disabled) {
      e.preventDefault();
      return;
    }

    var newChecked = !checked;
    var event = {
      target: {
        value: value,
        checked: newChecked,
        name: name
      }
    };
    onChange(event, newChecked);
  }, [onChange, checked, name]);

  return _react["default"].createElement(Wrap, _extends({
    disabled: disabled,
    minHeight: 36,
    alignItems: "flex-start",
    display: "flex",
    onClick: toggle
  }, props), _react["default"].createElement(_Box["default"], {
    flexShrink: 0
  }, checked ? _react["default"].cloneElement(checkedIcon, {
    color: color
  }) : uncheckedIcon), label && _react["default"].createElement(_Typography.Text, {
    pt: "2px",
    ml: 2
  }, label));
}

Checkbox.propTypes = {
  disabled: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  checked: _propTypes["default"].bool.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  name: _propTypes["default"].string
};
Checkbox.defaultProps = {
  color: 'teal',
  disabled: false,
  uncheckedIcon: _react["default"].createElement(_UncheckedIcon["default"], null),
  checkedIcon: _react["default"].createElement(_CheckedIcon["default"], null) // indeterminateIcon: <IndeterminateIcon/>,

};
var _default = Checkbox;
exports["default"] = _default;